import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import reasonCodes from 'config/reason-codes';
import Alert from 'components/ui/tailwind/Alert';
import DropdownButton from 'components/ui/tailwind/DropdownButton';
import _ from 'underscore';
import classnames from 'classnames';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
class ShipmentStatusReasonCaptureModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            reason: {},
        };
    }
    onResolve() {
        const { t } = this.props;
        this.props.onResolve(this.props.exception._id, t('REASON_CAPTURED'), this.state.reason);
        this.props.onCancel();
    }
    getSaveButton() {
        const disabled = _.isEmpty(this.state.reason);
        const classNames = classnames({
            'bg-green': true,
            'hover:bg-green-dark': true,
            'text-white': true,
            'py-2': true,
            'px-4': true,
            rounded: true,
            'border-green-darker': true,
            shadow: true,
            'mr-2': true,
            'opacity-50': disabled === true,
            'cursor-not-allowed': disabled === true,
        });
        const { t } = this.props;
        return (React.createElement("button", { type: "button", disabled: disabled, onClick: () => this.onResolve(), className: classNames }, t('RESOLVE')));
    }
    render() {
        const { t } = this.props;
        return (React.createElement(Modal, { show: this.props.show, onHide: () => this.props.onCancel() },
            React.createElement(Modal.Header, { closeButton: true },
                React.createElement(Modal.Title, null, t('REASON_CAPTURE'))),
            React.createElement(Modal.Body, null,
                React.createElement("div", { className: "" },
                    React.createElement(Alert, { status: "red", message: t('CUSTOMER_REQUIRE_REASON_FOR_EARLY_PICKUP') }),
                    React.createElement("div", { className: "my-3" },
                        React.createElement("span", null, t('SELECT_REASON_TO_DESCRIBE_SITUATION'))),
                    React.createElement("div", { className: "flex" },
                        React.createElement("div", { className: "w-3/4" },
                            React.createElement(DropdownButton, { onSelect: (reason) => this.setState({ reason }), items: reasonCodes, title: t(this.state.reason.localizationSlug) || t('SELECT_REASON') }))))),
            React.createElement(Modal.Footer, null,
                React.createElement("div", { className: "mt-1 float-right" },
                    this.getSaveButton(),
                    React.createElement("a", { onClick: () => this.props.onCancel() }, t('CANCEL'))))));
    }
}
ShipmentStatusReasonCaptureModal.propTypes = {
    onResolve: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    show: PropTypes.bool.isRequired,
};
export default withTranslation()(ShipmentStatusReasonCaptureModal);
